module.exports = __webpack_public_path__ + "img/australia-flag.7bf22410.png";